import { useDispatch } from 'react-redux';
import { useAppSelector } from '../../stateManagement/hooks/redux';
import { setHasChosenYearPathNormativitiesInfo, setHasChosenYearPathNormativitiesMapMeasureType, setHasChosenYearPathNormativitiesMapMeasureTypesGroup, setMapUnionMode, setYearPathNormativitiesInfo, setYearPathNormativitiesMap } from '../../stateManagement/reducers/diagnostics/PathNormativitiesSlice';
import { applyMeasureTypeOnMap, setMapNormativityFlag } from "../../stateManagement/reducers/diagnostics/PathNormativitiesSlice";
import { setPeriodRoadMeasureResults, setType } from "../../stateManagement/reducers/diagnostics/DiagnosticsRoadMeasureResultsSlice";
import { Checkbox } from "primereact/checkbox";
import { InputSwitch } from "primereact/inputswitch";
import { Button } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import { Slider } from '@mui/material';
import { getItemWebStorage, setItemWebStorage } from '../../features/webStorageSaver';
import { useEffect } from 'react';
import { classNames } from 'primereact/utils';
import { setRoadAccidentSegmentsMapYearFilter } from '../../stateManagement/reducers/objectTypes/RoadAccidentSegmentsSlice';

const intersectionModeIconSrc = require('../../assets/images/icons/filters/venn_diagram_intersection.svg').default
const unionModeIconSrc = require('../../assets/images/icons/filters/venn_diagram_union.svg').default

let reverseIndex: any = {
    4: 0,
    3: 1,
    2: 2,
    1: 3,
    0: 4
}

function formMarksForRange(currentYear: number) {
    let marks = [];
    for (let i = 4; i >= 0; i--) {
        marks.push({
            value: currentYear - i,
            label: `${currentYear - reverseIndex[i]}`
        })
    }
    return marks
}

function getInvertedValues(currentYear: number) {
    let obj: any = {}
    for (let i = 4; i >= 0; i--) {
        const field = currentYear - i;
        const value = currentYear - reverseIndex[i]
        obj[field] = value
    }
    return obj
}

const measureTypesNames = [
    {
        value: 'Roughness',
        name: 'Ровность'
    },
    {
        value: 'Defects',
        name: 'Дефекты'
    },
    {
        value: 'GaugeDepth',
        name: 'Колейность'
    },
    {
        value: 'Strength',
        name: 'Прочность'
    },
    {
        value: 'Cohesion',
        name: 'Сцепление'
    },
]

// Страница выбора дополнительных слоев для карты
export function DiagnosticsYearFilters({ type, filterType }: any) {
    const containsMap = window.location.pathname.includes('map');
    const containsGroupingsDiagnostics = window.location.pathname.includes('diagnosticsMeasureResults');
    const navigate = useNavigate()
    const dispatch = useDispatch();
    const currentYear = new Date().getFullYear();
    const lastFiveYears = Array.from({ length: 5 }, (_, index) => currentYear - index);
    const chosenPathNormativitiesYearInfo = useAppSelector(state => state.diagnosticsPathNormativities.yearInfo)

    const chosenPathNormativitiesYearMap = useAppSelector(state => state.diagnosticsPathNormativities.pathNormativitiesMapYearFilter)
    const chosenMapMultipleMeasureTypes = useAppSelector(state => state.diagnosticsPathNormativities.pathNormativitiesMapMultipleMeasureTypes)
    const mapNormativityFlag = useAppSelector(state => state.diagnosticsPathNormativities.pathNormativitiesMapNormativityFlag)
    const mapUnionMode = useAppSelector(state => state.diagnosticsPathNormativities.pathNormativitiesMapUnionMode)

    const chosenRoadAccidentSegmentsMapYearFilter = useAppSelector(state => state.roadAccidentSegments.roadAccidentSegmentsMapYearFilter)

    const chosenRoadMeasureResultsYear = useAppSelector(state => state.diagnosticsRoadMeasureResults.period)
    const typeWhat = useAppSelector(state => state.diagnosticsRoadMeasureResults.type)

    function yearChangePathNormativitiesInfo(event: any) {
        dispatch(setYearPathNormativitiesInfo((event.target.innerHTML)))
        setItemWebStorage('diagnosticsYearFilters', { ...getItemWebStorage('diagnosticsYearFilters'), pathNormativitiesInfo: event.target.innerHTML })
        dispatch(setHasChosenYearPathNormativitiesInfo(true))
    }

    function yearChangePathNormativitiesMap(event: any) {
        dispatch(setYearPathNormativitiesMap((event.target.innerHTML)))
        setItemWebStorage('diagnosticsYearFilters', { ...getItemWebStorage('diagnosticsYearFilters'), pathNormativitiesMap: event.target.innerHTML })
    }

    function yearChangeRoadAccidentSegmentsMap(event: any) {
        dispatch(setRoadAccidentSegmentsMapYearFilter((event.target.innerHTML)))
        setItemWebStorage('diagnosticsYearFilters', { ...getItemWebStorage('diagnosticsYearFilters'), roadAccidentSegmentsMap: event.target.innerHTML })
    }

    function yearChangeRoadMeasureResults(event: any) {
        dispatch(setPeriodRoadMeasureResults((event.target.innerHTML)))
        setItemWebStorage('diagnosticsYearFilters', { ...getItemWebStorage('diagnosticsYearFilters'), roadMeasureResults: event.target.innerHTML })
        setItemWebStorage('diagnosticsYearFilters', { ...getItemWebStorage('diagnosticsYearFilters'), roadMeasureResultsType: 'single' })
        dispatch(setType('single'))
    }

    function handleYearChangeMeasureResultsSlider(event: Event, newValue: any, activeThumb: number) {
        if (newValue === currentYear - 4) {
            dispatch(setPeriodRoadMeasureResults(`${currentYear}`))
            setItemWebStorage('diagnosticsYearFilters', { ...getItemWebStorage('diagnosticsYearFilters'), roadMeasureResults: `${currentYear}` })
        } else {
            dispatch(setPeriodRoadMeasureResults(`${values[newValue]}-${currentYear}`))
            setItemWebStorage('diagnosticsYearFilters', { ...getItemWebStorage('diagnosticsYearFilters'), roadMeasureResults: `${values[newValue]}-${currentYear}` })
        }
        setItemWebStorage('diagnosticsYearFilters', { ...getItemWebStorage('diagnosticsYearFilters'), roadMeasureResultsType: 'segment' })
        dispatch(setType('segment'))
    }

    function applyMeasureType(event: any) {
        let newObject = { ...chosenMapMultipleMeasureTypes, [event.value]: event.checked }
        dispatch(applyMeasureTypeOnMap(newObject))
    }

    const chosenYear = useAppSelector(state => state.diagnosticsRoadMeasureResults.period)
    const typeFromTable = useAppSelector(state => state.diagnosticsRoadMeasureResults.type)
    const values: any = getInvertedValues(currentYear)
    const marks = formMarksForRange(currentYear)

    let chosenYearForSlider = values[chosenYear]
    if (chosenYear.includes('-')) {
        chosenYearForSlider = values[chosenYear.split('-')[0]]
    }

    function valuetext(value: number) {
        const newValue = values[value]
        if (newValue == currentYear) {
            return `${currentYear}`
        } else {
            return `${newValue}-${currentYear}`
        }
    }

    useEffect(() => {
        if (type != 'header') {
            if (filterType === 'PathNormativitiesInfo') {
                setItemWebStorage('diagnosticsYearFilters', { ...getItemWebStorage('diagnosticsYearFilters'), pathNormativitiesInfoSeen: true })
            }
            if (filterType === 'PathNormativitiesMapMeasureType') {
                setItemWebStorage('diagnosticsYearFilters', { ...getItemWebStorage('diagnosticsYearFilters'), pathNormativitiesMapSeen: true })
            }
            if (filterType === 'PathNormativitiesMapMeasureTypesGroup') {
                setItemWebStorage('diagnosticsYearFilters', { ...getItemWebStorage('diagnosticsYearFilters'), pathNormativitiesMapMeasureTypeGroupsSeen: true })
            }
            if (filterType === 'RoadMeasureResults') {
                setItemWebStorage('diagnosticsYearFilters', { ...getItemWebStorage('diagnosticsYearFilters'), roadMeasureResultsSeen: true })
            }
            if (filterType === 'RoadAccidentSegmentsMap') {
                setItemWebStorage('diagnosticsYearFilters', { ...getItemWebStorage('diagnosticsYearFilters'), roadAccidentSegmentsMapSeen: true })
            }
        }
    }, [])

    function handleResetMeasureResultsButtonClick() {
        dispatch(setPeriodRoadMeasureResults(`${new Date().getFullYear()}`))
        dispatch(setType('single'))
    }

    function handleResetPathNormativitiesInfoButtonClick() {
        dispatch(setYearPathNormativitiesInfo(`${new Date().getFullYear()}`))
    }

    function handleResetPathNormativitiesMapButtonClick() {
        dispatch(setYearPathNormativitiesMap(`${new Date().getFullYear()}`))
        if (filterType === 'PathNormativitiesMapMeasureTypesGroup') {
            dispatch(applyMeasureTypeOnMap({ Roughness: true }))
            dispatch(setMapNormativityFlag(true))
            dispatch(setMapUnionMode('intersection'))
            dispatch(setHasChosenYearPathNormativitiesMapMeasureTypesGroup(true))
        }
        if (filterType === 'PathNormativitiesMapMeasureType') {
            dispatch(setHasChosenYearPathNormativitiesMapMeasureType(true))
        }
    }

    function handleResetRoadAccidentSegmentsMapButtonClick() {
        dispatch(setRoadAccidentSegmentsMapYearFilter(`${new Date().getFullYear()}`))
    }

    let pathNormativitiesInfoDivClassName = (year: any) => classNames({
        "single-year-container": true,
        "single-year-container-active": `${year}` === chosenPathNormativitiesYearInfo
    })

    let pathNormativitiesMapDivClassName = (year: any) => classNames({
        "single-year-container": true,
        "single-year-container-active": `${year}` === chosenPathNormativitiesYearMap
    })

    let roadAccidentSegmentsMapDivClassName = (year: any) => classNames({
        "single-year-container": true,
        "single-year-container-active": `${year}` === chosenRoadAccidentSegmentsMapYearFilter
    })

    let roadMeasureResultsDivClassName = (year: any) => classNames({
        "single-year-container": true,
        "single-year-container-active": (typeWhat == "single" && `${year}` === chosenRoadMeasureResultsYear)
    })

    let roadMeasureResultsSpanClassName = classNames({
        "single-year": true,
        "single-year-container-disabled": typeWhat != 'single'
    })

    let segmentYearFilterDivClassName = classNames({
        "segment-year-filter-div-active": typeFromTable == "segment",
        "segment-year-filter-div-disabled": typeFromTable !== "segment"
    })

    function switchMapUnionMode() {
        const newMapUnionMode = mapUnionMode === 'union' ? 'intersection' : 'union'
        dispatch(setMapUnionMode(newMapUnionMode))
    }

    return (
        <>
            {type === 'header' ?
                <div className="year-filter-div">
                    <div className="me-4 ms-4 single-year-filter-div">
                        {lastFiveYears.map((year: any) => {
                            return (
                                <div key={year}>
                                    {filterType === 'PathNormativitiesInfo' &&
                                        <div className={pathNormativitiesInfoDivClassName(year)}>
                                            <span onClick={(e) => yearChangePathNormativitiesInfo(e)} className="single-year">{year}</span>
                                        </div>
                                    }
                                    {filterType === 'PathNormativitiesMapMeasureType' &&
                                        <div className={pathNormativitiesMapDivClassName(year)}>
                                            <span onClick={(e) => yearChangePathNormativitiesMap(e)} className="single-year">{year}</span>
                                        </div>
                                    }
                                    {filterType === 'RoadAccidentSegmentsMap' &&
                                        <div className={roadAccidentSegmentsMapDivClassName(year)}>
                                            <span onClick={(e) => yearChangeRoadAccidentSegmentsMap(e)} className="single-year">{year}</span>
                                        </div>
                                    }
                                    {filterType === 'PathNormativitiesMapMeasureTypesGroup' &&
                                        <div className={pathNormativitiesMapDivClassName(year)}>
                                            <span onClick={(e) => yearChangePathNormativitiesMap(e)} className="single-year">{year}</span>
                                        </div>
                                    }
                                    {filterType === 'RoadMeasureResults' &&
                                        <div className={roadMeasureResultsDivClassName(year)}>
                                            <span onClick={(e) => yearChangeRoadMeasureResults(e)} className={roadMeasureResultsSpanClassName}>{year}</span>
                                        </div>
                                    }
                                </div>
                            )
                        })}
                    </div>
                    {filterType === 'PathNormativitiesMapMeasureTypesGroup' &&
                        <>
                            <div className="measure-types-choose-div">
                                {measureTypesNames.map(measureType => (
                                    <div key={measureType.value} className="flex align-items-center choose-div">
                                        <Checkbox inputId={measureType.value} value={measureType.value} onChange={applyMeasureType} checked={chosenMapMultipleMeasureTypes[measureType.value]} />
                                        <label htmlFor={measureType.value} className="me-3 ms-2">{measureType.name}</label>
                                    </div>
                                ))
                                }
                            </div>
                            <div className="filter-mode-switch-div">
                                <InputSwitch checked={mapNormativityFlag} inputId="mapNormativityFlag" onChange={(e) => dispatch(setMapNormativityFlag(e.value))} />
                                <label htmlFor="mapNormativityFlag">{mapNormativityFlag ? 'В нормативе' : 'Не в нормативе'}</label>
                            </div>
                            <div className="filter-mode-switch-div" onClick={switchMapUnionMode}>
                                <img className='filter-mode-img' src={mapUnionMode === 'intersection' ? intersectionModeIconSrc : unionModeIconSrc} />
                                <label>{mapUnionMode === 'intersection' ? 'Пересечение' : 'Объединение'}</label>
                            </div>
                        </>
                    }
                </div>
                :
                <div className="path-normativities-filters-page">
                    <div className="path-normativities-head mt-3 mb-2">
                        <span>ВЫБЕРИТЕ ГОД:</span>
                    </div>
                    <div className="single-year-filter-div">
                        {lastFiveYears.map((year: any) => {
                            return (
                                <div key={year}>
                                    {filterType === 'PathNormativitiesInfo' &&
                                        <div className={pathNormativitiesInfoDivClassName(year)}>
                                            <span onClick={(e) => yearChangePathNormativitiesInfo(e)} className="single-year">{year}</span>
                                        </div>
                                    }
                                    {filterType === 'PathNormativitiesMapMeasureType' &&
                                        <div className={pathNormativitiesMapDivClassName(year)}>
                                            <span onClick={(e) => yearChangePathNormativitiesMap(e)} className="single-year">{year}</span>
                                        </div>
                                    }
                                    {filterType === 'RoadAccidentSegmentsMap' &&
                                        <div className={roadAccidentSegmentsMapDivClassName(year)}>
                                            <span onClick={(e) => yearChangeRoadAccidentSegmentsMap(e)} className="single-year">{year}</span>
                                        </div>
                                    }
                                    {filterType === 'PathNormativitiesMapMeasureTypesGroup' &&
                                        <div className={pathNormativitiesMapDivClassName(year)}>
                                            <span onClick={(e) => yearChangePathNormativitiesMap(e)} className="single-year">{year}</span>
                                        </div>
                                    }
                                    {filterType === 'RoadMeasureResults' &&
                                        <div className={roadMeasureResultsDivClassName(year)}>
                                            <span onClick={(e) => yearChangeRoadMeasureResults(e)} className={roadMeasureResultsSpanClassName}>{year}</span>
                                        </div>
                                    }
                                </div>
                            )
                        })}
                    </div>
                    {filterType === 'PathNormativitiesInfo' &&
                        <div className="d-flex">
                            <Button className="mt-3 apply-layers-button" onClick={() => navigate(-1)}>Применить</Button>
                            <Button className="mt-3 cancel-all-layers-button" onClick={handleResetPathNormativitiesInfoButtonClick}>Сбросить</Button>
                        </div>
                    }
                    {filterType === 'PathNormativitiesMapMeasureType' &&
                        <div className="d-flex">
                            <Button className="mt-3 apply-layers-button" onClick={() => navigate(-1)}>Применить</Button>
                            <Button className="mt-3 cancel-all-layers-button" onClick={handleResetPathNormativitiesMapButtonClick}>Сбросить</Button>
                        </div>
                    }
                    {filterType === 'RoadAccidentSegmentsMap' &&
                        <div className="d-flex">
                            <Button className="mt-3 apply-layers-button" onClick={() => navigate(-1)}>Применить</Button>
                            <Button className="mt-3 cancel-all-layers-button" onClick={handleResetRoadAccidentSegmentsMapButtonClick}>Сбросить</Button>
                        </div>
                    }
                    {(filterType === 'PathNormativitiesMapMeasureTypesGroup') &&
                        <>
                            <hr></hr>
                            <div className="path-normativities-head mt-3 mb-2">
                                <span>ВЫБЕРИТЕ ТИПЫ ДИАГНОСТИКИ:</span>
                            </div>
                            {filterType === 'PathNormativitiesMapMeasureTypesGroup' &&
                                <>
                                    <div className="measure-types-choose-div">
                                        {measureTypesNames.map(measureType => (
                                            <div key={measureType.value} className="choose-div">
                                                <Checkbox inputId={measureType.value} value={measureType.value} onChange={applyMeasureType} checked={chosenMapMultipleMeasureTypes[measureType.value]} />
                                                <label htmlFor={measureType.value} className="me-3 ms-2">{measureType.name}</label>
                                            </div>
                                        ))
                                        }
                                    </div>
                                    <hr></hr>
                                    <div className="path-normativities-head mt-3 mb-2">
                                        <span>СМЕНА НОРМАТИВНОСТИ:</span>
                                    </div>
                                    <div className="input-switch-div">
                                        <InputSwitch checked={mapNormativityFlag} inputId="mapNormativityFlag" onChange={(e) => dispatch(setMapNormativityFlag(e.value))} />
                                        <label htmlFor="mapNormativityFlag" className="map-normativity-flag-label">{mapNormativityFlag ? 'В нормативе' : 'Не в нормативе'}</label>
                                    </div>
                                    <div className="path-normativities-head mt-3 mb-2">
                                        <span>СМЕНА РЕЖИМА ОБЪЕДИНЕНИЯ:</span>
                                    </div>
                                    <div className='filter-div'>
                                        <div className="filter-mode-switch-div" onClick={switchMapUnionMode}>
                                            <img className='filter-mode-img' src={mapUnionMode === 'intersection' ? intersectionModeIconSrc : unionModeIconSrc} />
                                            <label>{mapUnionMode === 'intersection' ? 'Пересечение' : 'Объединение'}</label>
                                        </div>
                                    </div>
                                </>
                            }
                            <div className="d-flex">
                                <Button className="mt-3 apply-layers-button" onClick={() => navigate(-1)}>Применить</Button>
                                <Button className="mt-3 cancel-all-layers-button" onClick={handleResetPathNormativitiesMapButtonClick}>Сбросить</Button>
                            </div>
                        </>
                    }
                    {!containsMap && containsGroupingsDiagnostics &&
                        <>
                            <hr></hr>
                            <div className="years-slider">
                                <div>
                                    <div className="segment-year-label-div">
                                        <div className="path-normativities-head mt-3 mb-2">
                                            <span>ЗА НЕСКОЛЬКО ЛЕТ: самые актуальные</span>
                                        </div>
                                    </div>
                                    <div className={segmentYearFilterDivClassName} >
                                        <div className="segment-year-filter">
                                            <Slider
                                                style={(typeFromTable !== 'segment') ? { color: '#bdbdbd' } : {}}
                                                defaultValue={(typeFromTable == 'segment') ? chosenYearForSlider : values[new Date().getFullYear()]}
                                                valueLabelFormat={valuetext}
                                                onChange={handleYearChangeMeasureResultsSlider}
                                                valueLabelDisplay="auto"
                                                step={1}
                                                marks={marks}
                                                min={currentYear - 4}
                                                max={currentYear}
                                                size="small"
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div >
                            <div className="d-flex">
                                <Button className="mt-3 apply-layers-button" onClick={() => navigate(-1)}>Применить</Button>
                                <Button className="mt-3 cancel-all-layers-button" onClick={handleResetMeasureResultsButtonClick}>Сбросить</Button>
                            </div>
                        </>
                    }
                </div>
            }
        </>
    );
}

